import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { DashboardQueryProps, PayoutSummary } from "@customTypes/dashboard";

import { dashboardQKeys } from "./queryKeys";


const select = (res: any) => {
  //   console.log(res.data);

  const newData = {} as PayoutSummary;
  if (Object.keys(res.data).length) {
    const {
      total_paid_in,
      outstanding_pay_ins,
      total_paid_out,
      outstanding_payouts,
    } = res.data;
    newData.outstandingPayIns = {
      services: outstanding_pay_ins.count,
      amount: outstanding_pay_ins.total_amount,
    };
    newData.totalPaidIn = {
      services: total_paid_in.count,
      amount: total_paid_in.total_amount,
    };
    newData.totalPaidOut = {
      services: total_paid_out.count,
      amount: total_paid_out.total_amount,
    };
    newData.outstandingPayOuts = {
      services: outstanding_payouts.count,
      amount: outstanding_payouts.total_amount,
    };
    return newData;
  }

  return null;
};

export const useGetPayoutSummary = ({
  dateRange,
  startDate,
  endDate,
}: DashboardQueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: dashboardQKeys.payoutSummaryWithFilters({
      dateRange,
      startDate,
      endDate,
    }),
    queryFn: () => {
      return api.get(`analytics/earnings/payout-summary`, {
        params: {
          range: dateRange?.replaceAll("-", "_"),
          ...(dateRange === "custom" && {
            start_date: startDate,
            end_date: endDate,
          }),
        },
      });
    },
    select,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled:
      dateRange !== "custom" ||
      !!(dateRange === "custom" && startDate && endDate),

    onError: (res: any) => {
      console.error("[From Get Payout Summary]", res);
      handleErrors(res, "query");
    },
  });
};
